<template>
  <teleport to="body">
    <div v-if="visible && bloque" class="cfg-overlay">
      <div class="cfg-modal">

        <div class="cfg-header">
          <h3>Configurar &mdash; {{ tipoLabel }}</h3>
          <button class="btn-cerrar" @click="emit('cerrar')">&#x2715;</button>
        </div>

        <div class="cfg-body">

          <!-- KPIS_RESUMEN -->
          <template v-if="bloque.tipo === 'KPIS_RESUMEN'">
            <p class="cfg-desc">Seleccione las tarjetas que desea mostrar.</p>
            <div class="check-grid">
              <label v-for="k in KPIS" :key="k.clave" class="check-item">
                <input type="checkbox" :checked="kpiActivo(k.clave)" @change="toggleKpi(k.clave)" />
                {{ k.label }}
              </label>
            </div>
          </template>

          <!-- TABLAS -->
          <template v-else-if="esTabla">

            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Columnas del sistema</div>
              <div class="check-grid">
                <label v-for="c in columnasSistema" :key="c.clave" class="check-item">
                  <input type="checkbox" :checked="colActiva(c.clave)" @change="toggleColumna(c.clave)" />
                  {{ c.label }}
                </label>
              </div>
            </div>

            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Columnas de texto adicionales</div>
              <p class="cfg-desc">
                Columnas personalizadas con texto libre por
                {{ bloque.tipo === 'TABLA_GENERAL' ? 'factor' : bloque.tipo === 'TABLA_SEMAFORO' ? 'aspecto' : 'componente' }}.
              </p>

              <div class="nueva-col-form">
                <input
                  v-model="nuevoTituloCol"
                  class="input-col"
                  placeholder="Nombre de la columna..."
                  @keyup.enter="agregarColumnaExtra"
                />
                <button class="btn-add-col" :disabled="!nuevoTituloCol.trim()" @click="agregarColumnaExtra">
                  Añadir
                </button>
              </div>

              <div v-if="columnasExtra.length" class="extra-cols-lista">
                <div v-for="ec in columnasExtra" :key="ec.id" class="extra-col-bloque">
                  <div class="extra-col-head">
                    <input v-model="ec.titulo" class="input-col-titulo" placeholder="Nombre de la columna" />
                    <button class="btn-elim-col" @click="eliminarColumnaExtra(ec.id)">&#x2715; Eliminar</button>
                  </div>
                  <div v-if="filasExtraDisponibles.length" class="extra-filas">
                    <div v-for="fila in filasExtraDisponibles" :key="fila.key" class="extra-fila">
                      <span class="extra-fila-label">{{ fila.label }}</span>
                      <input v-model="ec.filas[fila.key]" class="input-fila" placeholder="Texto..." />
                    </div>
                  </div>
                  <p v-else class="cfg-desc">Sin datos disponibles.</p>
                </div>
              </div>
              <p v-else class="sin-extra">Sin columnas adicionales.</p>
            </div>

          </template>

          <!-- GRAFICOS_TODOS -->
          <template v-else-if="bloque.tipo === 'GRAFICOS_TODOS'">
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Factores a mostrar</div>
              <div class="check-grid">
                <label v-for="f in factoresStore" :key="f.id_componente" class="check-item">
                  <input type="checkbox" :checked="factorActivo(f.id_componente)" @change="toggleFactor(f.id_componente)" />
                  {{ fmtOrdinal(f.ordinal) }} {{ f.nombre }}
                </label>
              </div>
            </div>
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Altura del gráfico</div>
              <div class="radio-row">
                <label v-for="a in ALTURAS" :key="a.valor" class="radio-item">
                  <input v-model="draft.altura" type="radio" :value="a.valor" />
                  {{ a.label }}
                </label>
              </div>
            </div>
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Ancho de cada tarjeta</div>
              <div class="radio-row">
                <label v-for="a in ANCHOS" :key="a.valor" class="radio-item">
                  <input v-model="draft.ancho" type="radio" :value="a.valor" />
                  {{ a.label }}
                </label>
              </div>
            </div>
          </template>

          <!-- GRAFICO_FACTOR -->
          <template v-else-if="bloque.tipo === 'GRAFICO_FACTOR'">
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Altura del gráfico</div>
              <div class="radio-row">
                <label v-for="a in ALTURAS" :key="a.valor" class="radio-item">
                  <input v-model="draft.altura" type="radio" :value="a.valor" />
                  {{ a.label }}
                </label>
              </div>
            </div>
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Ancho de la tarjeta</div>
              <div class="radio-row">
                <label v-for="a in ANCHOS" :key="a.valor" class="radio-item">
                  <input v-model="draft.ancho" type="radio" :value="a.valor" />
                  {{ a.label }}
                </label>
              </div>
            </div>
          </template>

          <!-- COMPARATIVO -->
          <template v-else-if="bloque.tipo === 'COMPARATIVO'">
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Vista inicial</div>
              <div class="radio-row">
                <label class="radio-item">
                  <input type="radio" v-model="draft.vista" value="tabla" /> Tabla
                </label>
                <label class="radio-item">
                  <input type="radio" v-model="draft.vista" value="grafico" /> Gráfico
                </label>
              </div>
            </div>
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Factores a mostrar</div>
              <p class="cfg-desc">Seleccione los factores que aparecerán en el comparativo. Sin selección se muestran todos.</p>
              <div class="check-grid">
                <label v-for="f in factoresStore" :key="f.id_componente" class="check-item">
                  <input type="checkbox" :checked="factorComparativoActivo(f.id_componente)" @change="toggleFactorComparativo(f.id_componente)" />
                  {{ fmtOrdinal(f.ordinal) }} {{ f.nombre }}
                </label>
              </div>
            </div>
          </template>

          <!-- IMAGEN -->
          <template v-else-if="bloque.tipo === 'IMAGEN'">
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Fuente de la imagen</div>
              <div class="img-fuente-tabs">
                <button class="img-tab" :class="{ activo: imgFuente === 'url' }" @click="imgFuente = 'url'">URL remota</button>
                <button class="img-tab" :class="{ activo: imgFuente === 'archivo' }" @click="imgFuente = 'archivo'">Desde el equipo</button>
              </div>
              <template v-if="imgFuente === 'url'">
                <input v-model="draft.url" class="input-full" placeholder="https://…" style="margin-top:8px" />
              </template>
              <template v-else>
                <div class="archivo-zona" @click="fileInputRef?.click()">
                  <input ref="fileInputRef" type="file" accept="image/*" style="display:none" @change="cargarArchivo" />
                  <span v-if="draft.url && draft.url.startsWith('data:')" class="archivo-ok">
                    Imagen cargada — haga clic para cambiar
                  </span>
                  <span v-else class="archivo-placeholder">Haga clic para seleccionar una imagen del equipo</span>
                </div>
              </template>
            </div>
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Texto alternativo</div>
              <input v-model="draft.alt" class="input-full" placeholder="Descripción de la imagen" />
            </div>
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Pie de imagen (opcional)</div>
              <input v-model="draft.titulo" class="input-full" placeholder="Texto bajo la imagen…" />
            </div>
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Ancho</div>
              <div class="radio-row">
                <label v-for="a in ANCHOS_IMG" :key="a.valor" class="radio-item">
                  <input type="radio" v-model="draft.ancho" :value="a.valor" /> {{ a.label }}
                </label>
              </div>
            </div>
          </template>

          <!-- TABLA_CUSTOM -->
          <template v-else-if="bloque.tipo === 'TABLA_CUSTOM'">
            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Título de la tabla</div>
              <input v-model="draft.titulo" class="input-full" placeholder="Título (opcional)" />
            </div>

            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Importar datos</div>
              <p class="cfg-desc">Seleccione la fuente y las columnas que desea cargar.</p>
              <div class="import-fuente-row">
                <button
                  v-for="opt in TC_FUENTES"
                  :key="opt.id"
                  class="btn-import"
                  :class="{ activo: tcFuente === opt.id }"
                  @click="seleccionarFuente(opt.id)"
                >{{ opt.label }}</button>
                <button class="btn-import btn-import--elim" @click="vaciarTabla">Vaciar tabla</button>
              </div>
              <template v-if="tcFuente">
                <div class="import-cols-grid">
                  <label
                    v-for="col in TC_COLUMNAS[tcFuente]"
                    :key="col.clave"
                    class="check-item"
                  >
                    <input
                      type="checkbox"
                      :checked="tcColumnas.includes(col.clave)"
                      @change="toggleTcColumna(col.clave)"
                    />
                    {{ col.label }}
                  </label>
                </div>
                <button class="btn-add-col" :disabled="!tcColumnas.length" @click="importarDatos">
                  Importar / Reemplazar tabla
                </button>
              </template>
            </div>

            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Encabezados de columna</div>
              <div class="tabla-header-row">
                <div v-for="(h, ci) in (draft.headers ?? [])" :key="ci" class="tabla-header-cell">
                  <div class="tabla-header-reorder">
                    <button class="btn-reorder" :disabled="ci === 0" @click="moverColumna(ci, -1)">&#8592;</button>
                    <button class="btn-reorder" :disabled="ci === (draft.headers?.length ?? 0) - 1" @click="moverColumna(ci, 1)">&#8594;</button>
                  </div>
                  <input v-model="draft.headers[ci]" class="input-fila" placeholder="Columna" />
                  <button class="btn-elim-mini" @click="eliminarColumnaTabla(ci)">✕</button>
                </div>
                <button class="btn-add-col" @click="agregarColumnaTabla">+ Col</button>
              </div>
            </div>

            <div class="cfg-seccion">
              <div class="cfg-seccion-titulo">Filas</div>
              <div v-for="(row, ri) in (draft.rows ?? [])" :key="ri" class="tabla-fila-row">
                <textarea
                  v-for="(cell, ci) in row"
                  :key="ci"
                  v-model="draft.rows[ri][ci]"
                  class="input-fila-area"
                  rows="1"
                  placeholder="…"
                ></textarea>
                <button class="btn-elim-mini" @click="eliminarFilaTabla(ri)">✕</button>
              </div>
              <button class="btn-add-col" style="margin-top:0.5rem" @click="agregarFilaTabla">+ Fila</button>
            </div>
          </template>

        </div>

        <div class="cfg-footer">
          <button class="btn salir" @click="emit('cerrar')">Cancelar</button>
          <button class="btn guardar" @click="aplicar">Aplicar</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
/**
 * Configuración de un bloque del informe.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

import { ref, computed, watch } from 'vue'
import { useGestionResultadosAutoevaluacion } from '@/store/GestionResultadosAutoevaluacion'
import type { NodoResultado, AspectoResultado } from '@/interfaces/ResultadosAutoevaluacion'

type TcFuente = 'factores' | 'caracteristicas' | 'aspectos'

interface BloqueDesc { id: string; tipo: string; params?: Record<string, any> }
interface ExtraColumna { id: string; titulo: string; filas: Record<string, string> }

const props = defineProps<{ visible: boolean; bloque: BloqueDesc | null }>()
const emit = defineEmits<{
  (e: 'cerrar'): void
  (e: 'guardar', payload: { id: string; params: Record<string, any> }): void
}>()

const store = useGestionResultadosAutoevaluacion()

function sortByOrdinal(a: string | null | undefined, b: string | null | undefined): number {
  const ap = (a ?? '').split('.').map(n => parseInt(n, 10) || 0)
  const bp = (b ?? '').split('.').map(n => parseInt(n, 10) || 0)
  for (let i = 0; i < Math.max(ap.length, bp.length); i++) {
    const d = (ap[i] ?? 0) - (bp[i] ?? 0)
    if (d !== 0) return d
  }
  return 0
}

const factoresStore = computed(() =>
  [...(store.resultados?.factores ?? [])].sort((a, b) => sortByOrdinal(a.ordinal, b.ordinal))
)

function fmtOrdinal(ordinal: string | null | undefined): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length <= 1 ? ordinal : parts.slice(1).join('.')
}

// ── Constantes ────────────────────────────────────────────────────────────────

const KPIS = [
  { clave: 'total',     label: 'Total indicadores' },
  { clave: 'evaluados', label: 'Evaluados' },
  { clave: 'promedio',  label: 'Promedio general' },
  { clave: 'nivel',     label: 'Nivel general' },
]

const ALTURAS = [
  { valor: 'sm', label: 'Pequeño' },
  { valor: 'md', label: 'Mediano' },
  { valor: 'lg', label: 'Grande' },
]

const ANCHOS = [
  { valor: 'sm', label: 'Pequeño (300 px)' },
  { valor: 'md', label: 'Mediano (420 px)' },
  { valor: 'lg', label: 'Grande (560 px)' },
]

const COLUMNAS_SISTEMA: Record<string, { clave: string; label: string }[]> = {
  TABLA_GENERAL: [
    { clave: 'n_factor',      label: 'N Factor' },
    { clave: 'nombre_factor', label: 'Factor' },
    { clave: 'peso_factor',   label: 'Ponderacion' },
    { clave: 'n_caract',      label: 'N Caract.' },
    { clave: 'nombre_caract', label: 'Caracteristica' },
    { clave: 'aspecto',       label: 'Aspecto' },
    { clave: 'valoracion',    label: 'Valoracion' },
    { clave: 'gradacion',     label: 'Gradacion' },
    { clave: 'pct',           label: 'Pond.' },
    { clave: 'nivel',         label: 'Nivel' },
  ],
  TABLA_SEMAFORO: [
    { clave: 'caract',     label: 'Caracteristica' },
    { clave: 'aspecto',    label: 'Aspecto' },
    { clave: 'valoracion', label: 'Valoracion' },
    { clave: 'fuerte',     label: 'Fuerte' },
    { clave: 'debil',      label: 'Debil' },
    { clave: 'muy_debil',  label: 'Muy debil' },
  ],
  TABLA_ESTRUCTURA: [
    { clave: 'codigo',        label: 'Codigo' },
    { clave: 'tipo',          label: 'Tipo' },
    { clave: 'nombre',        label: 'Nombre' },
    { clave: 'peso',          label: 'Ponderacion' },
    { clave: 'valoracion',    label: 'Valoracion' },
    { clave: 'pct',           label: '%' },
    { clave: 'grado',         label: 'Grado' },
    { clave: 'clasificacion', label: 'Clasificacion' },
  ],
}

const ANCHOS_IMG = [
  { valor: '25%',  label: '25%' },
  { valor: '50%',  label: '50%' },
  { valor: '75%',  label: '75%' },
  { valor: '100%', label: '100%' },
]

const TC_FUENTES = [
  { id: 'factores'        as TcFuente, label: 'Factores' },
  { id: 'caracteristicas' as TcFuente, label: 'Características' },
  { id: 'aspectos'        as TcFuente, label: 'Aspectos' },
]

const TC_COLUMNAS: Record<TcFuente, { clave: string; label: string; default: boolean }[]> = {
  factores: [
    { clave: 'ordinal',      label: 'Ordinal',          default: false },
    { clave: 'nombre',       label: 'Factor',            default: true  },
    { clave: 'calificacion', label: 'Calificación',      default: true  },
    { clave: 'nivel',        label: 'Nivel / Grado',     default: true  },
    { clave: 'peso',         label: 'Peso / Ponderación', default: false },
  ],
  caracteristicas: [
    { clave: 'ordinal',      label: 'Ordinal',           default: false },
    { clave: 'factor',       label: 'Factor',             default: false },
    { clave: 'nombre',       label: 'Característica',     default: true  },
    { clave: 'calificacion', label: 'Calificación',       default: true  },
    { clave: 'nivel',        label: 'Nivel / Grado',      default: true  },
    { clave: 'peso',         label: 'Peso / Ponderación', default: false },
  ],
  aspectos: [
    { clave: 'ordinal',      label: 'Ordinal',           default: false },
    { clave: 'factor',       label: 'Factor',             default: false },
    { clave: 'caract',       label: 'Característica',     default: false },
    { clave: 'nombre',       label: 'Aspecto',            default: true  },
    { clave: 'calificacion', label: 'Calificación',       default: true  },
    { clave: 'grado',        label: 'Nivel / Grado',      default: false },
  ],
}

// Mapa plano para evitar el patron }[key] que confunde el parser Vue SFC
const TIPO_LABELS: Record<string, string> = {
  KPIS_RESUMEN:     'KPIs de resumen',
  TABLA_GENERAL:    'Tabla general',
  TABLA_SEMAFORO:   'Tabla semaforo',
  TABLA_ESTRUCTURA: 'Estructura jerarquica',
  GRAFICOS_TODOS:   'Todos los graficos',
  GRAFICO_FACTOR:   'Grafico por factor',
  COMPARATIVO:      'Comparativo',
  IMAGEN:           'Imagen',
  TABLA_CUSTOM:     'Tabla personalizada',
}

// ── Estado local (draft) ──────────────────────────────────────────────────────

const draft          = ref<Record<string, any>>({})
const nuevoTituloCol = ref('')
const imgFuente      = ref<'url' | 'archivo'>('url')
const fileInputRef   = ref<HTMLInputElement | null>(null)
const tcFuente       = ref<TcFuente | ''>('')
const tcColumnas     = ref<string[]>([])

watch(() => props.visible, (v) => {
  if (v && props.bloque) {
    draft.value = JSON.parse(JSON.stringify(props.bloque.params ?? {}))
    const tipo = props.bloque.tipo
    if (['GRAFICOS_TODOS', 'GRAFICO_FACTOR'].includes(tipo)) {
      if (!draft.value.altura) draft.value.altura = 'md'
      if (!draft.value.ancho)  draft.value.ancho  = 'md'
    }
    if (!draft.value.columnasExtra) draft.value.columnasExtra = []
    if (tipo === 'COMPARATIVO') {
      if (!draft.value.vista) draft.value.vista = 'tabla'
      if (!draft.value.filtroComponentes) draft.value.filtroComponentes = []
    }
    if (tipo === 'IMAGEN') {
      if (!draft.value.ancho) draft.value.ancho = '100%'
      imgFuente.value = (draft.value.url as string | undefined)?.startsWith('data:') ? 'archivo' : 'url'
    }
    if (tipo === 'TABLA_CUSTOM') {
      if (!draft.value.headers) draft.value.headers = ['', '', '']
      if (!draft.value.rows)    draft.value.rows    = [['', '', '']]
      tcFuente.value   = ''
      tcColumnas.value = []
    }
    nuevoTituloCol.value = ''
  }
})

// ── Computeds ─────────────────────────────────────────────────────────────────

const tipoLabel = computed(() => TIPO_LABELS[props.bloque?.tipo ?? ''] ?? props.bloque?.tipo ?? '')

const esTabla = computed(() =>
  ['TABLA_GENERAL', 'TABLA_SEMAFORO', 'TABLA_ESTRUCTURA'].includes(props.bloque?.tipo ?? '')
)

const columnasSistema = computed(() => COLUMNAS_SISTEMA[props.bloque?.tipo ?? ''] ?? [])

const columnasExtra = computed<ExtraColumna[]>(() => draft.value.columnasExtra ?? [])

function recolectarAspectos(nodo: NodoResultado): AspectoResultado[] {
  return [...nodo.aspectos, ...nodo.hijos.flatMap(recolectarAspectos)]
}

const filasExtraDisponibles = computed<{ key: string; label: string }[]>(() => {
  const tipo = props.bloque?.tipo
  const datos = store.resultados
  if (!datos || !tipo) return []

  if (tipo === 'TABLA_GENERAL') {
    return datos.factores.map(f => ({
      key: 'f_' + f.id_componente,
      label: (fmtOrdinal(f.ordinal) ? fmtOrdinal(f.ordinal) + ' ' : '') + f.nombre
    }))
  }

  if (tipo === 'TABLA_SEMAFORO') {
    const rows: { key: string; label: string }[] = []
    for (const f of datos.factores) {
      const caracts = f.hijos.length ? f.hijos : [f]
      for (const c of caracts) {
        for (const a of recolectarAspectos(c)) {
          rows.push({ key: 'a_' + a.id_indicador, label: (a.ordinal ? fmtOrdinal(a.ordinal) + '. ' : '') + a.nombre })
        }
      }
    }
    return rows
  }

  if (tipo === 'TABLA_ESTRUCTURA') {
    const rows: { key: string; label: string }[] = []
    const walk = (n: NodoResultado) => {
      rows.push({ key: 'c_' + n.id_componente, label: (fmtOrdinal(n.ordinal) ? fmtOrdinal(n.ordinal) + ' ' : '') + n.nombre })
      for (const h of n.hijos) walk(h)
    }
    for (const f of datos.factores) walk(f)
    return rows
  }

  return []
})

// ── Operaciones sobre el draft ────────────────────────────────────────────────

function colActiva(clave: string): boolean {
  return !draft.value.columnas || draft.value.columnas.includes(clave)
}

function toggleColumna(clave: string): void {
  const defCols = columnasSistema.value.map(c => c.clave)
  if (!draft.value.columnas) draft.value.columnas = [...defCols]
  const idx: number = draft.value.columnas.indexOf(clave)
  if (idx >= 0) draft.value.columnas.splice(idx, 1)
  else draft.value.columnas.push(clave)
}

function kpiActivo(clave: string): boolean {
  return !draft.value.tarjetas || draft.value.tarjetas.includes(clave)
}

function toggleKpi(clave: string): void {
  if (!draft.value.tarjetas) draft.value.tarjetas = KPIS.map(k => k.clave)
  const idx: number = draft.value.tarjetas.indexOf(clave)
  if (idx >= 0) draft.value.tarjetas.splice(idx, 1)
  else draft.value.tarjetas.push(clave)
}

function factorActivo(id: number): boolean {
  return !draft.value.factoresIds || draft.value.factoresIds.includes(id)
}

function toggleFactor(id: number): void {
  const allIds = factoresStore.value.map(f => f.id_componente)
  if (!draft.value.factoresIds) draft.value.factoresIds = [...allIds]
  const idx: number = draft.value.factoresIds.indexOf(id)
  if (idx >= 0) draft.value.factoresIds.splice(idx, 1)
  else draft.value.factoresIds.push(id)
}

function agregarColumnaExtra(): void {
  const titulo = nuevoTituloCol.value.trim()
  if (!titulo) return
  if (!draft.value.columnasExtra) draft.value.columnasExtra = []
  draft.value.columnasExtra.push({ id: crypto.randomUUID(), titulo, filas: {} })
  nuevoTituloCol.value = ''
}

function eliminarColumnaExtra(id: string): void {
  if (!draft.value.columnasExtra) return
  draft.value.columnasExtra = draft.value.columnasExtra.filter((c: ExtraColumna) => c.id !== id)
}

// ── COMPARATIVO ───────────────────────────────────────────────────────────────

function factorComparativoActivo(id: number): boolean {
  const filtro = draft.value.filtroComponentes as number[] | undefined
  return !filtro?.length || filtro.includes(id)
}

function toggleFactorComparativo(id: number): void {
  const allIds = factoresStore.value.map(f => f.id_componente)
  if (!draft.value.filtroComponentes || !(draft.value.filtroComponentes as number[]).length) {
    draft.value.filtroComponentes = allIds.filter(x => x !== id)
  } else {
    const arr = draft.value.filtroComponentes as number[]
    const idx = arr.indexOf(id)
    if (idx >= 0) arr.splice(idx, 1)
    else arr.push(id)
    if (arr.length === allIds.length) draft.value.filtroComponentes = []
  }
}

// ── TABLA_CUSTOM ──────────────────────────────────────────────────────────────

function agregarColumnaTabla(): void {
  if (!draft.value.headers) draft.value.headers = []
  if (!draft.value.rows)    draft.value.rows    = []
  draft.value.headers.push('')
  for (const row of draft.value.rows as string[][]) row.push('')
}

function eliminarColumnaTabla(ci: number): void {
  if (!draft.value.headers) return
  draft.value.headers.splice(ci, 1)
  if (draft.value.rows) {
    for (const row of draft.value.rows as string[][]) row.splice(ci, 1)
  }
}

function moverColumna(ci: number, dir: -1 | 1): void {
  const headers = draft.value.headers as string[]
  const rows    = draft.value.rows    as string[][]
  const ti = ci + dir
  if (!headers || ti < 0 || ti >= headers.length) return
  ;[headers[ci], headers[ti]] = [headers[ti], headers[ci]]
  for (const row of (rows ?? [])) {
    const tmp = row[ci]; row[ci] = row[ti]; row[ti] = tmp
  }
}

function agregarFilaTabla(): void {
  if (!draft.value.rows) draft.value.rows = []
  const cols = (draft.value.headers as string[] ?? []).length || 1
  ;(draft.value.rows as string[][]).push(new Array(cols).fill(''))
}

function eliminarFilaTabla(ri: number): void {
  if (!draft.value.rows) return
  ;(draft.value.rows as string[][]).splice(ri, 1)
}

// ── IMAGEN ────────────────────────────────────────────────────────────────────

function cargarArchivo(e: Event): void {
  const file = (e.target as HTMLInputElement).files?.[0]
  if (!file) return
  const reader = new FileReader()
  reader.onload = (ev) => { draft.value.url = ev.target?.result as string }
  reader.readAsDataURL(file)
}

// ── TABLA_CUSTOM ──────────────────────────────────────────────────────────────

function seleccionarFuente(id: TcFuente): void {
  if (tcFuente.value === id) {
    tcFuente.value   = ''
    tcColumnas.value = []
    return
  }
  tcFuente.value   = id
  tcColumnas.value = TC_COLUMNAS[id].filter(c => c.default).map(c => c.clave)
}

function toggleTcColumna(clave: string): void {
  const idx = tcColumnas.value.indexOf(clave)
  if (idx >= 0) tcColumnas.value.splice(idx, 1)
  else tcColumnas.value.push(clave)
}

function vaciarTabla(): void {
  draft.value.headers = ['', '', '']
  draft.value.rows    = [['', '', '']]
  tcFuente.value      = ''
  tcColumnas.value    = []
}

function importarDatos(): void {
  const fuente = tcFuente.value as TcFuente
  const cols   = tcColumnas.value
  if (!fuente || !cols.length) return
  const datos = store.resultados
  if (!datos) return

  draft.value.headers = cols.map(c => TC_COLUMNAS[fuente].find(d => d.clave === c)?.label ?? c)

  const rows: string[][] = []

  if (fuente === 'factores') {
    for (const f of datos.factores) {
      rows.push(cols.map(c => {
        if (c === 'ordinal')      return fmtOrdinal(f.ordinal) || '—'
        if (c === 'nombre')       return f.nombre
        if (c === 'calificacion') return f.valoracion != null ? (f.valoracion as number).toFixed(2) : '—'
        if (c === 'nivel')        return f.grado ?? '—'
        if (c === 'peso')         return (f as any).peso != null ? String((f as any).peso) : '—'
        return '—'
      }))
    }
  } else if (fuente === 'caracteristicas') {
    for (const f of datos.factores) {
      const factorLabel = (fmtOrdinal(f.ordinal) ? fmtOrdinal(f.ordinal) + ' ' : '') + f.nombre
      for (const c of (f.hijos.length ? f.hijos : [f])) {
        rows.push(cols.map(col => {
          if (col === 'factor')       return factorLabel
          if (col === 'ordinal')      return fmtOrdinal(c.ordinal) || '—'
          if (col === 'nombre')       return c.nombre
          if (col === 'calificacion') return c.valoracion != null ? (c.valoracion as number).toFixed(2) : '—'
          if (col === 'nivel')        return c.grado ?? '—'
          if (col === 'peso')         return (c as any).peso != null ? String((c as any).peso) : '—'
          return '—'
        }))
      }
    }
  } else if (fuente === 'aspectos') {
    for (const f of datos.factores) {
      const factorLabel = (fmtOrdinal(f.ordinal) ? fmtOrdinal(f.ordinal) + ' ' : '') + f.nombre
      for (const caract of (f.hijos.length ? f.hijos : [f])) {
        const caractLabel = (fmtOrdinal(caract.ordinal) ? fmtOrdinal(caract.ordinal) + ' ' : '') + caract.nombre
        for (const a of recolectarAspectos(caract)) {
          rows.push(cols.map(col => {
            if (col === 'factor')       return factorLabel
            if (col === 'caract')       return caractLabel
            if (col === 'ordinal')      return a.ordinal ?? '—'
            if (col === 'nombre')       return a.nombre
            if (col === 'calificacion') return a.valoracion != null ? a.valoracion.toFixed(2) : '—'
            if (col === 'grado')        return a.grado ?? '—'
            return '—'
          }))
        }
      }
    }
  }

  draft.value.rows = rows
}

function aplicar(): void {
  if (!props.bloque) return
  emit('guardar', { id: props.bloque.id, params: JSON.parse(JSON.stringify(draft.value)) })
}
</script>

<style scoped>
.cfg-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 3000;
  display: flex; align-items: center; justify-content: center; padding: 1rem;
}
.cfg-modal {
  background: white; border-radius: 12px; box-shadow: 0 8px 36px rgba(0,0,0,0.28);
  width: 100%; max-width: 720px; max-height: 88vh;
  display: flex; flex-direction: column; overflow: hidden;
}
.cfg-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 1rem 1.25rem; border-bottom: 1px solid #e0e0e0; flex-shrink: 0;
}
.cfg-header h3 { margin: 0; font-size: 1rem; font-weight: 700; color: #1a1a1a; }
.btn-cerrar {
  background: none; border: none; font-size: 1.1rem; cursor: pointer;
  color: #888; padding: 0; line-height: 1; transition: color 0.15s;
}
.btn-cerrar:hover { color: #dc3545; }

.cfg-body {
  padding: 1.25rem; overflow-y: auto; flex: 1;
  display: flex; flex-direction: column; gap: 1.25rem;
}
.cfg-desc { font-size: 0.85rem; color: #555; margin: 0 0 0.5rem; }

.cfg-seccion { display: flex; flex-direction: column; gap: 0.6rem; }
.cfg-seccion-titulo {
  font-size: 0.75rem; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.07em; color: #0e69a0; padding-bottom: 6px;
  border-bottom: 1px solid #e8f0f8;
}

.check-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 6px; }
.check-item {
  display: flex; align-items: center; gap: 8px; padding: 6px 10px;
  border: 1px solid #e8e8e8; border-radius: 6px; cursor: pointer;
  font-size: 0.85rem; color: #333; transition: background 0.1s;
}
.check-item:hover { background: #f5faff; }
.check-item input { accent-color: #0e69a0; width: 15px; height: 15px; flex-shrink: 0; }

.radio-row { display: flex; gap: 0.75rem; flex-wrap: wrap; }
.radio-item {
  display: flex; align-items: center; gap: 7px; padding: 6px 14px;
  border: 1px solid #e0e0e0; border-radius: 6px; cursor: pointer;
  font-size: 0.85rem; color: #333; transition: all 0.1s;
}
.radio-item:hover { border-color: #0e69a0; background: #f5faff; }
.radio-item input { accent-color: #0e69a0; }

.nueva-col-form { display: flex; gap: 8px; align-items: center; }
.input-col {
  flex: 1; padding: 6px 10px; border: 1px solid #ccc; border-radius: 6px;
  font-size: 0.85rem; font-family: inherit;
}
.input-col:focus { outline: none; border-color: #0e69a0; }
.btn-add-col {
  padding: 6px 14px; border: 1px solid #0e69a0; border-radius: 6px;
  background: #0e69a0; color: white; font-weight: 600; font-size: 0.82rem;
  cursor: pointer; font-family: inherit; flex-shrink: 0; transition: background 0.15s;
}
.btn-add-col:disabled { opacity: 0.4; cursor: not-allowed; }
.btn-add-col:hover:not(:disabled) { background: #0b5580; }

.sin-extra { font-size: 0.82rem; color: #aaa; font-style: italic; margin: 0; }

.extra-cols-lista { display: flex; flex-direction: column; gap: 1rem; margin-top: 0.5rem; }
.extra-col-bloque { border: 1px solid #d0e2f0; border-radius: 8px; overflow: hidden; }
.extra-col-head {
  display: flex; align-items: center; gap: 8px;
  padding: 8px 12px; background: #eaf3fb; border-bottom: 1px solid #d0e2f0;
}
.input-col-titulo {
  flex: 1; padding: 5px 9px; border: 1px solid #c0d4e8; border-radius: 5px;
  font-size: 0.85rem; font-weight: 600; font-family: inherit; background: white;
}
.input-col-titulo:focus { outline: none; border-color: #0e69a0; }
.btn-elim-col {
  padding: 4px 10px; border: 1px solid #dc3545; border-radius: 5px;
  background: white; color: #dc3545; font-size: 0.75rem; font-weight: 600;
  cursor: pointer; font-family: inherit; flex-shrink: 0; transition: all 0.15s;
}
.btn-elim-col:hover { background: #dc3545; color: white; }

.extra-filas { max-height: 260px; overflow-y: auto; display: flex; flex-direction: column; }
.extra-fila {
  display: flex; align-items: center; gap: 10px;
  padding: 6px 12px; border-bottom: 1px solid #f0f0f0;
}
.extra-fila:last-child { border-bottom: none; }
.extra-fila-label {
  flex: 0 0 220px; font-size: 0.8rem; color: #444;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.input-fila {
  flex: 1; padding: 4px 8px; border: 1px solid #ddd; border-radius: 4px;
  font-size: 0.82rem; font-family: inherit;
}
.input-fila:focus { outline: none; border-color: #0e69a0; }

.input-full {
  width: 100%; padding: 6px 10px; border: 1px solid #ccc; border-radius: 6px;
  font-size: 0.85rem; font-family: inherit; box-sizing: border-box;
}
.input-full:focus { outline: none; border-color: #0e69a0; }

.btn-import {
  padding: 5px 14px; border: 1px solid #0e69a0; border-radius: 6px;
  background: white; color: #0e69a0; font-weight: 600; font-size: 0.8rem;
  cursor: pointer; font-family: inherit; transition: all 0.15s;
}
.btn-import:hover { background: #0e69a0; color: white; }
.btn-import--elim { border-color: #ccc; color: #666; }
.btn-import--elim:hover { background: #f5f5f5; color: #333; }

.tabla-header-row { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; }
.tabla-header-cell { display: flex; flex-direction: column; align-items: stretch; gap: 2px; }
.tabla-header-reorder { display: flex; gap: 2px; }
.btn-reorder {
  flex: 1; padding: 1px 6px; border: 1px solid #ccc; border-radius: 3px;
  background: white; color: #555; font-size: 0.75rem; cursor: pointer;
  line-height: 1.4; transition: all 0.1s;
}
.btn-reorder:hover:not(:disabled) { border-color: #0e69a0; color: #0e69a0; background: #f0f7fc; }
.btn-reorder:disabled { opacity: 0.3; cursor: not-allowed; }
.tabla-fila-row { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; margin-bottom: 4px; }

.btn-elim-mini {
  padding: 2px 7px; border: 1px solid #dc3545; border-radius: 4px;
  background: white; color: #dc3545; font-size: 0.7rem; font-weight: 700;
  cursor: pointer; flex-shrink: 0; transition: all 0.1s;
}
.btn-elim-mini:hover { background: #dc3545; color: white; }

/* IMAGEN: fuente tabs */
.img-fuente-tabs { display: flex; gap: 6px; margin-bottom: 2px; }
.img-tab {
  padding: 5px 14px; border: 1px solid #d0d0d0; border-radius: 6px;
  background: #fff; color: #555; font-size: 0.82rem; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: all 0.12s;
}
.img-tab.activo { background: #0e69a0; border-color: #0e69a0; color: #fff; }
.img-tab:not(.activo):hover { border-color: #0e69a0; color: #0e69a0; }
.archivo-zona {
  margin-top: 8px; padding: 18px 14px; border: 2px dashed #b0cfe4; border-radius: 8px;
  cursor: pointer; text-align: center; background: #f5faff; transition: background 0.12s;
}
.archivo-zona:hover { background: #e8f3fb; }
.archivo-ok { font-size: 0.85rem; color: #0f6e56; font-weight: 600; }
.archivo-placeholder { font-size: 0.85rem; color: #777; }

/* TABLA_CUSTOM: import controls */
.import-fuente-row { display: flex; gap: 8px; flex-wrap: wrap; }
.btn-import.activo { background: #0e69a0; color: white; border-color: #0e69a0; }
.import-cols-grid {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 6px; margin: 8px 0;
}
.input-fila-area {
  flex: 1; padding: 4px 8px; border: 1px solid #ddd; border-radius: 4px;
  font-size: 0.82rem; font-family: inherit; resize: vertical;
  min-height: 28px; max-height: 100px; overflow-y: auto; box-sizing: border-box;
}
.input-fila-area:focus { outline: none; border-color: #0e69a0; }

.cfg-footer {
  display: flex; gap: 0.75rem; justify-content: flex-end;
  padding: 0.9rem 1.25rem; border-top: 1px solid #e0e0e0; flex-shrink: 0;
}
.btn {
  padding: 0.55rem 1.2rem; font-weight: 600; border: none; border-radius: 8px;
  cursor: pointer; font-family: inherit; font-size: 0.9rem; transition: all 0.15s;
}
.btn.salir { background: white; border: 1px solid #ccc; color: #333; }
.btn.salir:hover { background: #f5f5f5; }
.btn.guardar { background: #eea222; color: #1a1a1a; }
.btn.guardar:hover { background: #0e69a0; color: white; }
</style>
